'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "btn-justify"
    }, [_c('button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      on: {
        "click": function click($event) {
          _vm.$emit('clickLeft');
        }
      }
    }, [_vm._v(_vm._s(_vm.left))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      on: {
        "click": function click($event) {
          _vm.$emit('clickRight');
        }
      }
    }, [_vm._v(_vm._s(_vm.right))])]);
  },
  staticRenderFns: [],
  name: 'button-justify',
  props: {
    left: String,
    right: String
  }
});

exports.default = index;
